import type { ReactNode } from 'react';
import { FormattedNumber } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, BrandXL } from '@sorare/core/src/atoms/typography';
import type { Color } from '@sorare/core/src/style/types';

type Props = { color: Color; value: number; label: ReactNode };
export const Stat = ({ color, value, label }: Props) => {
  return (
    <Vertical center gap={0.5}>
      <BrandXL color={color}>
        <FormattedNumber value={value} signDisplay="always" />
      </BrandXL>
      <BrandS>{label}</BrandS>
    </Vertical>
  );
};
